import { deviceExplorerTypes } from "../actions/deviceExplorer";
import { authTypes } from "../actions/auth";
// import usDateFormatLast7Days from "../../global/utility/usDateFormatLast7Days";
// const { startDateTime, endDateTime } = usDateFormatLast7Days(new Date());
const endDateTime = new Date();
const startDateTime = new Date().setTime(new Date() - 1000 * 60 * 60 * 24 );

const initialState = {
  currentId: "",
  isLoading: false,
  startDateTime: startDateTime,
  endDateTime: endDateTime,
  selectedAggregation: "median",
  aggregation: "median",
  resolution: "15 minutes",
  formData:{
    firstName: {
      value: "",
      error: null,
    },
    lastName: "",
    email:""
  },
  seletedAttributes: [],
  data: {
    signalStrength: {
      first: [],
      last: [],
      count: [],
      max: [],
      min: [],
      median: [],
      mean: [],
      sum: [],
      std_dev: [],
    },
    "positionRadius (meters)": {
      first: [],
      last: [],
      count: [],
      max: [],
      min: [],
      median: [],
      mean: [],
      sum: [],
      std_dev: [],
    },
    battery: {
      first: [],
      last: [],
      count: [],
      max: [],
      min: [],
      median: [],
      mean: [],
      sum: [],
      std_dev: [],
    },
    rssi: {
      first: [],
      last: [],
      count: [],
      max: [],
      min: [],
      median: [],
      mean: [],
      sum: [],
      std_dev: [],
    },
    light: {
      first: [],
      last: [],
      count: [],
      max: [],
      min: [],
      median: [],
      mean: [],
      sum: [],
      std_dev: [],
    },
    humidity: {
      first: [],
      last: [],
      count: [],
      max: [],
      min: [],
      median: [],
      mean: [],
      sum: [],
      std_dev: [],
    },
    temperature: {
      first: [],
      last: [],
      count: [],
      max: [],
      min: [],
      median: [],
      mean: [],
      sum: [],
      std_dev: [],
    },
    pressure: {
      first: [],
      last: [],
      count: [],
      max: [],
      min: [],
      median: [],
      mean: [],
      sum: [],
      std_dev: [],
    }
  },
  error: "",
};

const deviceExplorerReducer = (state = initialState, action) => {
  switch (action.type) {
    case deviceExplorerTypes.UPDATE_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case deviceExplorerTypes.FETCH_DEVICE_EXPLORER_GRAPH_REQUEST:{
      const isSameDevice = state.currentId === action.payload.id;
      const seletedAttributes = state.seletedAttributes.length === 0 && action.payload.firstAttribute
        ? [action.payload.firstAttribute]
        : state.seletedAttributes;

      return {
        ...state,
        isLoading: true,
        currentId: action.payload.id,
        seletedAttributes: isSameDevice ? seletedAttributes : [action.payload.firstAttribute].filter(Boolean),
        data: {},
      };
    }
    case deviceExplorerTypes.FETCH_DEVICE_EXPLORER_GRAPH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        aggregation: state.selectedAggregation,
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
      };
    case deviceExplorerTypes.FETCH_DEVICE_EXPLORER_GRAPH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case authTypes.LOGOUT:
    case authTypes.AUTO_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default deviceExplorerReducer;
